// Copyright (c) 2016 Deere & Company

import Report, {getDefaultState} from '../state/report';
import actions from '../../actions-list';
import {sortCollection} from '../../../shared/services/collections';

const updateRegistrationReviewReport = (state, action) =>
    Report.update(state, {
        $set: action.data
    });

const sortRegistrationReviewReport = (state, action) => {

    const collection = [...action.collection];

    return Report.update(state, {
        $set: sortCollection(action.sortBy, action.sortDirection, collection)
    });

};

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.SORT_REGISTRATION_REVIEW_REPORT]: sortRegistrationReviewReport,
        [actions.CREATE_REGISTRATIONS_REVIEW_REPORT_SUCCESS]: updateRegistrationReviewReport,
        [actions.RESET_REPORT_SEARCH_RESULTS]: updateRegistrationReviewReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/registrations-review/reducers/report.js